import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialsModule } from '../../modules/material.module';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { FileUploadComponent } from './file-upload.component';
import { ExtensionIconPipe, UrlFileNamePipe } from './pipes';
import { ButtonsModule } from '../buttons/buttons.module';
import { FormFieldsModule } from '../form-fields/form-fields.module';
import { MatMenuModule } from '@angular/material/menu';
import { MenuOptionFileUploadComponent } from './cm-menu-option-file-upload/cm-menu-option-file-upload.component';

@NgModule({
  declarations: [FileUploadComponent, MenuOptionFileUploadComponent, ExtensionIconPipe, UrlFileNamePipe],
  imports: [
    CommonModule,
    FormsModule,
    MaterialsModule,
    TranslateModule,
    ButtonsModule,
    FormFieldsModule,
    MatMenuModule,
  ],
  exports: [FileUploadComponent, UrlFileNamePipe, MenuOptionFileUploadComponent],
})
export class FileUploadModule {}
